import { render } from "./NAttachmentsPicker.vue?vue&type=template&id=7353a19f&ts=true"
import script from "./NAttachmentsPicker.vue?vue&type=script&lang=ts"
export * from "./NAttachmentsPicker.vue?vue&type=script&lang=ts"

import "./NAttachmentsPicker.vue?vue&type=style&index=0&id=7353a19f&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__